<template>
  <v-col cols="5">
<!--    <v-list-item class="mt-5 "-->

<!--                 color="primary"-->
<!--                 dark-->
<!--                 @click.stop="dialog=true"-->
<!--    >-->
<!--                 <v-list-item-icon>-->
<!--                      <v-img src="../../../../../assets/svg/Decision.svg" class="decision-box"></v-img>-->
<!--                  </v-list-item-icon>-->

<!--                  <v-list-item-content>-->
<!--                      <v-list-item-title class="decision">Payment</v-list-item-title>-->
<!--                  </v-list-item-content>-->
<!--    </v-list-item>-->

    <v-card
        class="actions-card"
        @click.stop="dialog=true"
    >
      <v-card-actions class="text-center actions-btn">
        <v-btn text class="actions-btn-text"><v-img src="../../../../../assets/svg/payment.svg"></v-img> Payment</v-btn>
      </v-card-actions>
    </v-card>



    <v-dialog
        v-model="dialog"
        width="480"
    >
      <v-card>
        <Loader :loading="loading" :message="message"/>
        <v-toolbar class="box"  @click.stop="dialog = false">
          <v-icon>mdi-close</v-icon>
          <v-toolbar-title>Close</v-toolbar-title>
        </v-toolbar>
        <div class="comment-content">
          <v-card-title class="comment-heading">Kindly Enter<br/><br/>Payment Details </v-card-title>
          <br/>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form v-if="!submitted" @submit.prevent="handleSubmit(submitPayment)">
              <p class="err">{{serverResponse}}</p>
              <ValidationProvider name="Payment method" rules="required" v-slot="{errors}">
                <span class="err">{{ errors[0] }}</span>
                  <div class="row">
                    <v-select
                        :items="paymentModeArray"
                        v-model="paymentData.paymentMethod"
                        label="Payment Mode"
                        outlined
                    ></v-select>

        <!--            <v-col>-->
        <!--              <label class="payment-label">Payment Mode</label>-->
        <!--              <p class="payment-details">Bank Transfer</p>-->

        <!--            </v-col>-->
                  </div>
              </ValidationProvider>

              <ValidationProvider name="Date" rules="required" v-slot="{errors}">
                <span class="err">{{ errors[0] }}</span>
              <div class="row date-box">
                  <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      ref="menu1"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="paymentData.transactionDate"
                          label="Set new date "
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          class="ml-3 mr-2 invite-input"

                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" :min="new Date().toISOString().substr(0,10)" >
                      <v-spacer></v-spacer>
                      <v-btn  depressed color="primary" @click="menu1 = false">Cancel</v-btn>
                      <v-btn  depressed color="primary" @click="$refs.menu1.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
              </div>
              </ValidationProvider>
              <ValidationProvider name="Amount" rules="required" v-slot="{errors}">
                <span class="err">{{ errors[0] }}</span>
                    <div class="row">
                          <v-text-field outlined label="Amount" type="number" color="secondary" v-model="paymentData.amountPaid">

                          </v-text-field>
                    </div>
              </ValidationProvider>

          <div class="row">
            <v-text-field outlined label="Name of Depositor" color="secondary" v-model="paymentData.depositorName">

            </v-text-field>
          </div>
          <div class="row">
            <v-text-field outlined label="Account Name" color="secondary" v-model="paymentData.depositorAccountName">

            </v-text-field>
          </div>
              <ValidationProvider name="Amount" rules="required" v-slot="{errors}">
                <span class="err">{{ errors[0] }}</span>
                <div class="row">
                  <v-text-field outlined label="Bank Name" color="secondary" v-model="paymentData.originatingBankName">

                  </v-text-field>
                </div>
              </ValidationProvider>
          <div >
            <v-card-actions>
              <v-btn
                  color="red"
                  class="submit"
                  depressed
                  x-large
                  type="submit"
                  width="100%"
              >
                Submit
              </v-btn>

            </v-card-actions>
          </div>
            </form>
          </ValidationObserver>
        </div>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import Loader from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/Loader";
import axios from "axios";
import {uploadPayment} from "@/services/ApiServices";
import {mapGetters} from "vuex";
export default {
name: "PaymentModal",
  components:{
  Loader
  },
  data:vm=>({
      dialog: false,
      menu1:false,
      date: null,
      paymentModeArray:["USSD","BANK DEPOSIT","BANK TRANSFER"],
      paymentData:{
        paymentMethod:"",
        transactionDate:vm.formatDate(new Date().toISOString().substr(0, 10)),
        amountPaid:"",
        depositorName:"",
        depositorAccountName:"",
        originatingBankName:"",
        depositorEmail:""
      },
      message:"Loading",
      loading:false,
      submitted:false,
      serverResponse:''

  }),

  // mounted() {
  // this.dialog=true;
  // },
  methods:{
    submitPayment(){
      const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
      this.paymentData.paymentMethod = this.paymentData.paymentMethod.toLowerCase();
      this.paymentData.depositorEmail =this.applicantEmail
      let data = this.paymentData;
      this.loading=true
      axios.post(uploadPayment,data,{headers:elderHeader

      }).then(res=>{
        console.log(res.data)
        this.dialog=false;
        alert(res.data.message)
        
      }).catch(err=>{
        this.loading=false
        this.serverResponse= err.response.data.message
        alert(err.response.data.message)      })

    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    }
  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters(['applicantEmail','applicant'])
  },


  watch: {
    date () {
      this.transactionDate = this.formatDate(this.date)
    },
  },
}
</script>

<style scoped>
.comment-heading{
  font-weight: 500!important;
  font-size: 32px !important;
  line-height: 33px!important;
  letter-spacing: -0.02em;
  color: #2B1C1C !important;
  margin-left:-17px;
}

.box{
  box-shadow: none!important;
  cursor: pointer;
}
.comment-content{
  margin-left: 52px;
  margin-right: 52px;
  font-family: IBM Plex Sans !important;
  font-style: normal!important;
  font-weight: normal;

}
.payment-label{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;

  color: #2B1C1C;

}
.submit{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 25px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;

  color: #FFFFFF;


}
.date-box{
  margin-left: -22px !important;
  margin-right: -20px !important;
}
.decision{
  color: #00A998;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  display: flex;
  align-items: center !important;
  letter-spacing: 0.02em;

}
.err {
  color: red !important;
}
.decision-box{
  background: #C3F7E8;
  border-radius: 8px;
  padding: 3px;
}
.actions-btn{
  padding-top: 30px;
  margin-left: 45px;
}
.actions-btn-text{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  color: #2B1C1C;
  text-transform: capitalize!important;
}
.actions-card{
  border-radius: 8px;
  background: #FFF2C7;
  height: 95px;
}
.actions-text{
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 23px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;

  color: #960C0C;
}
</style>